export enum FeatureTypeEnum {
  List = 'list',
  CRUD = 'crud',
  Import = 'import',
  Export = 'export',
  Index = 'index'
}
